module.exports = __webpack_public_path__ + "media/loketpendaftaran2.bbd4b9c0.mp3";